// extracted by mini-css-extract-plugin
export default {"root":"IconCategoryTrees_root__k2y1a"};